// extracted by mini-css-extract-plugin
module.exports = {"InnerMenuStrip":"StripMenu_InnerMenuStrip__n08LJ","StripMenuItem":"StripMenu_StripMenuItem__7otyl","StripMenuItemTitle":"StripMenu_StripMenuItemTitle__NL9pF"};